import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import Header from '../components/header';
import SideNav from '../components/sidenav';
import Element from '../components/certificate_viewer';
import Loading from '../components/loading';

const Viewer = (props) => {
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [userType, setUserType] = useState('user');
    const [userId, setUserId] = useState('');
    const [storage, setStorage] = useState('');
    const [header_user_data, setHeaderUserData] = useState(null);
    const [documentLoaded, setDocumentLoaded] = useState(false);
    const [minNav, setMinNav] = useState(localStorage.getItem("minNav") === null ? false : JSON.parse(localStorage.getItem("minNav")));
    let { slug } = useParams();

    useEffect(() => {
        axios.defaults.withCredentials = true;
        axios.post(props.node_server_axios + 'session')
            .then((res) => {
                if (res.data !== undefined && res.data.email !== undefined && res.data.email !== '') {
                    setLoading(false);
                    setName(res.data.name);
                    setEmail(res.data.email);
                    setUserType(res.data.user_type);
                    setUserId(res.data.user_id);
                    setStorage(res.data.storage);
                    setHeaderUserData(res.data);
                } else {
                    window.location = '/signin';
                }
            })
            .catch(() => {
                window.location = '/signin';
            });
    }, [props.node_server_axios]);

    const handleDocumentLoaded = (e) => {
        setDocumentLoaded(e)
    }

    return loading ? (
        <React.Fragment>
            <div className="main">
                <Header />
                <Loading />
            </div>
        </React.Fragment>
    ) : (
        <React.Fragment>
            <div className="main">
                <Header login={true} user_data={header_user_data} email={email} node_server_axios={props.node_server_axios} documentLoaded={documentLoaded} />
                <div className='body-wrapper'>
                    <SideNav name={name} selected="allDocuments" user_type={userType} node_server_axios={props.node_server_axios} storage={storage} minifiedNav={setMinNav} />
                    <Element email={email} name={name} user_type={userType} userId={userId} storage={storage} documentId={slug} node_server_axios={props.node_server_axios} minNav={minNav} documentLoaded={handleDocumentLoaded} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default Viewer;